var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.36,
    height: 15.36,
    viewBox: "0 0 15.36 15.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3165",
    "data-name": "Rectangle 3165",
    width: 15.36,
    height: 15.36,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "closeWhite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus-round",
    d: "M13.424,8.267H9.973V4.816a.854.854,0,0,0-1.707,0v3.45H4.816a.854.854,0,0,0,0,1.707h3.45v3.451a.854.854,0,0,0,1.707,0V9.973h3.451a.854.854,0,0,0,0-1.707Z",
    transform: "translate(7.68 -5.218) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.23bbb35106122e79551581ba9a1f4c77.svg";
export { ForwardRef as ReactComponent };